import AliceCarousel from "react-alice-carousel";
import "./TutorCardsCarousel.scss";
import "react-alice-carousel/lib/scss/alice-carousel.scss";
import { useEffect, useMemo, useRef, useState } from "react";
import { axiosInstance } from "../../Utilities/Interceptor/Interceptor";
import { API_END_POINTS, AUTHENTICATION, GLOBAL_CONSTANTS, ROUTES } from "../../Constants/Constants";
import { useNavigate } from "react-router-dom";
import Tutorfavourites from "../../Assets/HeartFill/TutorFill.svg";
import toast from "react-hot-toast";
import { GetSessionStorageData, encryptPassData, nullUndefinedEmptyCheck } from "../../Utilities/Helpers/Helper";
import { setLoginSignUpOpen } from "../../Redux/Reducer/Reducer";
import { useDispatch, useSelector } from "react-redux";
import WebShareComponent from "../WebShare/WebShare";
import { useTranslation } from "react-i18next";

import card_bg from "../../Assets/Tutor/card_bg.png";
import tutor_img from "../../Assets/Tutor/tutor_image.png";
import share from "../../Assets/Tutor/share.svg";
import favourites from "../../Assets/Tutor/favourites.svg";
import location from "../../Assets/Tutor/location.svg";
import experience from "../../Assets/Tutor/experience.svg";
import teaching_mode from "../../Assets/Tutor/teaching_mode.svg";
import grades from "../../Assets/Tutor/grades.svg";
import curriculum from "../../Assets/Tutor/curriculum.svg";
import rating from "../../Assets/Tutor/rating.svg";
import left from "../../Assets/Tutor/left.svg";
import right from "../../Assets/Tutor/right.svg";

const TutorCardsCarousel = ({ radius, lat, lng, lang }: any) => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [popularList, setPopularList] = useState<any>([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const carouselRef = useRef<any>(null);

  const resolvedLng = lng ?? lang;

  const touchStartRef = useRef<number | null>(null);

  const totalSlides = useMemo(
    () => popularList.length + 1,
    [popularList]
  );

  const itemsToSlide = useMemo(() => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1024) return 3;
    if (screenWidth >= 600) return 2;
    return 1;
  }, []);

  useEffect(() => {
    console.log("Fetching tutors with:", { lat, lng: resolvedLng, radius });
    getPopular_TutorList();
  }, [lat, lng, lang, radius]);

  const navigateTutorDetailedView = (toturDetailes: any) => {
    navigate(
      ROUTES.TUTORS_DETAILE_VIEW + "?id=" + encryptPassData(toturDetailes?.id),
      { state: { tutor_Detailes: toturDetailes } }
    );
  };

  const mergePopularWithStoredTags = () => {
    try {
      const raw = GetSessionStorageData("TUTORS_WITH_TAG");
      console.log("Stored tags:", raw ? JSON.parse(raw) : null);
      const stored = raw ? JSON.parse(raw) : null;
      if (Array.isArray(stored) && stored.length > 0) {
        return popularList.map((p: any) => {
          const match = (stored as any[]).find((s) => s?.id === p?.id);
          return match ? { ...p, ...match, tag: match.tag ?? p.tag } : p;
        });
      }
    } catch {
      console.warn("Error parsing TUTORS_WITH_TAG");
    }
    return popularList;
  };

  const navigateTutorListView = () => {
    const mergedList = mergePopularWithStoredTags();
    navigate(ROUTES.TUTORS_LIST_VIEW, {
      state: {
        tutor_list: mergedList,
        search_text: '',
        radius,
        lat,
        lng: resolvedLng,
      },
    });
  };

  const slideNext = () => {
    const next = Math.min(
      activeIndex + itemsToSlide,
      Math.max(0, totalSlides - itemsToSlide)
    );
    setActiveIndex(next);
    carouselRef.current?.slideTo?.(next);
  };

  const slidePrev = () => {
    const prev = Math.max(activeIndex - itemsToSlide, 0);
    setActiveIndex(prev);
    carouselRef.current?.slideTo?.(prev);
  };

  const syncActiveIndex = ({ item }: any) => setActiveIndex(item);

 const getPopular_TutorList = () => {
  const payload: Record<string, any> = {
    radius: radius,
    search: "",
    price: [],
    experience: [],
    grade: [],
    courses: [],
    mode_of_teaching: [],
    gender: [],
    curriculum: [],
    rating: 0,
  };

  if (nullUndefinedEmptyCheck(lat) && !isNaN(parseFloat(lat))) {
    payload.latitude = lat.toString();
  }
  if (nullUndefinedEmptyCheck(resolvedLng) && !isNaN(parseFloat(resolvedLng))) {
    payload.longitude = resolvedLng.toString();
  }

  axiosInstance
    .post(`${API_END_POINTS.OPTIMIZED_TUTOR_LIST}`, payload)
    .then((response: any) => {
      console.log("Fetched tutors response:", response);

      if (response?.data?.status) {
        // 1. Get the raw list
        const tutors: any[] = response?.data?.result?.data || [];

        // 2. **Filter** tutors that have slots available
        const availableTutors = tutors.filter(
          (tutor) => tutor.is_slots_available === true
        );

        // 3. **Sort** by rating (descending)
        const sortedTutors = availableTutors.sort(
          (a: any, b: any) => (b.rating || 0) - (a.rating || 0)
        );

        setPopularList(sortedTutors);
        console.log(
          `Fetched ${sortedTutors.length} tutors (with slots) using payload:`,
          payload,
          sortedTutors
        );
      } else {
        console.warn("API returned non-successful status:", response?.data);
        setPopularList([]);
        toast.error(t("No tutors found with the current filters."), {
          position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
        });
      }
    })
    .catch((err) => {
      console.error("Error fetching tutors:", err);
      setPopularList([]);
      toast.error(t("Failed to fetch tutors. Please try again later."), {
        position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
      });
    });
};

  const handleChangeFavourites = (val: any, id: any) => {
    const accessToken = GetSessionStorageData(AUTHENTICATION.SHARED.ACCESS_TOKEN);
    if (nullUndefinedEmptyCheck(accessToken)) {
      const payload = {
        service_provider_type: 1,
        service_provider: id,
        is_favourite: !val,
      };
      axiosInstance
        .post(`${API_END_POINTS.FAVOURITE__ADD}`, payload)
        .then((response: any) => {
          if (response?.data?.status) {
            toast.success(response?.data?.message, {
              position: GLOBAL_CONSTANTS.INITIAL_VALUES.TOAST_POSITION,
            });
            getPopular_TutorList();
          }
        })
        .catch(() => {});
    } else {
      dispatch(setLoginSignUpOpen(GLOBAL_CONSTANTS.INITIAL_VALUES.TRUE));
    }
  };

  const language: any = useSelector((state: any) => state.languageReducer.language);

  const isTutorExpired = (tutor: any) => {
    if (tutor?.is_available === false) return true;
    if (tutor?.expiry_date) {
      const expiry = new Date(tutor.expiry_date);
      return expiry < new Date();
    }
    return false;
  };

  const onCardTouchStart = () => {
    touchStartRef.current = Date.now();
  };

  const onCardTouchEnd = (navigateFn: () => void) => {
    const dt = Date.now() - (touchStartRef.current || 0);
    touchStartRef.current = null;
    if (dt < 220) navigateFn();
  };

  const viewList = popularList.map((item: any, i: any) => (
    <div className="tutor_card_carousel_wrapper" key={i}>
      <div className="tutor_card_wrapper">
        <div
          className="cover_image_wrap"
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.stopPropagation();
            navigateTutorDetailedView(item);
          }}
          onTouchStart={onCardTouchStart}
          onTouchEnd={() => onCardTouchEnd(() => navigateTutorDetailedView(item))}
          onKeyDown={(e) => {
            if (e.key === "Enter") navigateTutorDetailedView(item);
          }}
        >
          <img
            className="card_bg_img"
            src={item?.cover_images?.length > 0 ? item?.cover_images[0] : card_bg}
            onError={(e: any) => {
              e.target.src = card_bg;
            }}
            alt="cover"
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
          />
          <img
            className="tutor_img"
            src={item?.profile_image ? item?.profile_image : tutor_img}
            onError={(e: any) => {
              e.target.src = tutor_img;
            }}
            alt="profile"
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
          />
        </div>

        <div className="tutor_details_wrapper">
          <div className="name_share_container">
            <div className="name_field notranslate">
              {language === "English"
                ? `${item.profile_details?.firstname || ""} ${item.profile_details?.lastname || ""}`.trim()
                : `${item.profile_details?.arabic_firstname || item.profile_details?.firstname} ${item.profile_details?.arabic_lastname || item.profile_details?.lastname}`.trim()}
            </div>

            <div className="share_fav_button">
              <WebShareComponent params={ROUTES.TUTORS_DETAILE_VIEW + "?id=" + encryptPassData(item?.id)}>
                <img src={share} className="mb-1" alt="share" draggable={false} onDragStart={(e) => e.preventDefault()} />
              </WebShareComponent>
              {item.is_favourite ? (
                <img
                  src={Tutorfavourites}
                  alt="fav"
                  onClick={() => handleChangeFavourites(item.is_favourite, item?.user)}
                  draggable={false}
                  onDragStart={(e) => e.preventDefault()}
                />
              ) : (
                <img
                  src={favourites}
                  alt="fav"
                  onClick={() => handleChangeFavourites(item.is_favourite, item?.user)}
                  draggable={false}
                  onDragStart={(e) => e.preventDefault()}
                />
              )}
            </div>
          </div>

          <div className="location_exp_mode_container" onClick={() => navigateTutorDetailedView(item)}>
            <div className="tutor_details_logo_container">
              <img className="tutor_details_logo" src={location} alt="loc" draggable={false} onDragStart={(e) => e.preventDefault()} />
              <div className="location" title={item.city}>{item.city}</div>
            </div>
            <div className="tutor_details_logo_container">
              <img className="tutor_details_logo" src={experience} alt="exp" draggable={false} onDragStart={(e) => e.preventDefault()} />
              <div className="location">{item?.tutor_subjects?.length > 0 ? item?.tutor_subjects[0]?.experience : ""}</div>
            </div>
            <div className="tutor_details_logo_container">
              <img className="tutor_details_logo" src={teaching_mode} alt="mode" draggable={false} onDragStart={(e) => e.preventDefault()} />
              <div className="location">{item?.tutor_subjects?.length > 0 ? item?.tutor_subjects[0]?.course_mode : ""}</div>
            </div>
          </div>

          <div className="location_exp_mode_container">
            <div className="tutor_details_logo_container">
              <img className="tutor_details_logo" src={grades} alt="grades" draggable={false} onDragStart={(e) => e.preventDefault()} />
              <div className="location" title={item?.tutor_subjects?.length > 0 ? item?.tutor_subjects[0]?.courses : ""}>
                {item?.tutor_subjects?.length > 0 ? item?.tutor_subjects[0]?.courses : ""}
              </div>
            </div>
            <div className="tutor_details_logo_container">
              <img className="tutor_details_logo" src={curriculum} alt="curriculum" draggable={false} onDragStart={(e) => e.preventDefault()} />
              <div className="location">{item.curriculum}</div>
            </div>
          </div>

          <div className="name_share_container">
            <div className="charges">{item?.tutor_subjects?.length > 0 ? "AED " + item?.tutor_subjects[0]?.final_fee : ""}</div>
            <div className="share_fav_button">
              {item.rating ? (
                <img src={rating} alt="rating" draggable={false} onDragStart={(e) => e.preventDefault()} />
              ) : (
                ""
              )}
              <div className="ratings">{item.rating}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));

  viewList.push(
    <div
      className="tutor_card_carousel_exploreAll__wapper"
      key="explore-all"
      onClick={(e) => {
        e.stopPropagation();
        navigateTutorListView();
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter") navigateTutorListView();
      }}
    >
      <div className="text">{t("Explore all")}</div>
      <div className="title">{t("Tutor")}</div>
    </div>
  );

  const ArrowNavLanguage =
    language === GLOBAL_CONSTANTS.LANGUAGES.ENGLISH ? "arrow_navs_english" : "arrow_navs_arabic";

  return (
    <div className="tutor_card_carousel_container">
      <div className="arrow_nav_tile_contianer">
        <div className="tutor_carousel_title">{t("Find Top Tutors")}</div>
        <div className={`arrow_navs me-2 ${ArrowNavLanguage}`}>
          <img
            src={left}
            onClick={slidePrev}
            alt="prev"
            className={activeIndex > 0 ? "left_arrow " : "disable_arrow"}
          />
          <img
            src={right}
            onClick={slideNext}
            alt="next"
            className={activeIndex < totalSlides - itemsToSlide ? "right_arrow" : "disable_arrow"}
          />
        </div>
      </div>

      <AliceCarousel
        mouseTracking
        touchTracking
        disableButtonsControls
        disableDotsControls
        items={viewList}
        onSlideChanged={syncActiveIndex}
        autoPlay={false}
        activeIndex={activeIndex}
        responsive={{ 0: { items: 1 }, 600: { items: 2 }, 1024: { items: 3 } }}
        ref={carouselRef}
      />
    </div>
  );
};

export default TutorCardsCarousel;